import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M361.297 308.986l139.846 139.846c14.478 14.477 14.474 37.953 0 52.427l.116-.115c-14.477 14.477-37.957 14.469-52.427-.001L308.986 361.297c-31.691 21.596-69.985 34.22-111.227 34.22C88.539 395.518 0 306.979 0 197.76 0 88.539 88.54 0 197.759 0c109.219 0 197.759 88.54 197.759 197.759 0 41.242-12.625 79.536-34.221 111.227zm-163.538 22.672c73.95 0 133.899-59.949 133.899-133.9 0-73.95-59.949-133.898-133.9-133.898-73.95 0-133.898 59.948-133.898 133.899 0 73.95 59.948 133.899 133.899 133.899z"
    })
  }));
};